import React from 'react';
import PropTypes from 'prop-types';
import { recordEvent } from '@department-of-veterans-affairs/platform-monitoring/exports';
import { focusElement } from '../../../../../utilities/ui/focus';
import { PROFILE_MENU_LINKS } from '../../../utilities/constants';

const ProfileMenuLinks = ({
  profile,
  closeMenu,
  focusedIndex,
  setFocusedIndex,
}) => {
  const links = document.querySelector('#nav__user-list')?.childNodes;

  const focusNextItem = () => {
    const nextIndex = focusedIndex === links.length - 1 ? 0 : focusedIndex + 1;
    setFocusedIndex(nextIndex);
    focusElement(links[nextIndex].firstChild);
  };

  const focusPreviousItem = () => {
    const previousIndex =
      focusedIndex === 0 ? links.length - 1 : focusedIndex - 1;
    setFocusedIndex(previousIndex);
    focusElement(links[previousIndex].firstChild);
  };

  const handleKeyDown = event => {
    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        focusNextItem();
        break;
      case 'ArrowUp':
        event.preventDefault();
        focusPreviousItem();
        break;
      case 'Escape':
      case 'Tab':
        closeMenu();
        focusElement('.arp-profile-dropdown');
        break;
      case 'Home':
        event.preventDefault();
        focusElement(links[0].firstChild);
        break;
      case 'End':
        event.preventDefault();
        focusElement(links[links.length - 1].firstChild);
        break;
      default:
        break;
    }
  };

  const handleClick = e => {
    closeMenu();
    recordEvent({
      // prettier-ignore
      'event': e.target.dataset.eventname,
      // prettier-ignore
      'custom_string_2': e.target.innerText || e.target.alt,
      'link-destination': e.target.href || e.target.baseURI,
      'link-origin': 'navigation',
    });
  };

  return (
    <>
      {PROFILE_MENU_LINKS.map((link, i) => {
        return (
          <li key={i} role="none">
            <a
              href={link.URL}
              onClick={handleClick}
              onKeyDown={handleKeyDown}
              className={`vads-u-color--black ${
                link.LABEL === 'Sign Out' ? 'nav__sign-out' : ''
              }`}
              data-testid={link.TEST_ID}
              data-eventname={link.EVENT_NAME}
              tabIndex="-1"
              role="menuitem"
            >
              {link.LABEL === 'Sign Out'
                ? `${link.LABEL} ${(
                    profile?.firstName ?? ''
                  ).toLowerCase()}`.trim()
                : link.LABEL}
            </a>
          </li>
        );
      })}
    </>
  );
};

ProfileMenuLinks.propTypes = {
  closeMenu: PropTypes.func,
  focusedIndex: PropTypes.number,
  profile: PropTypes.shape({
    firstName: PropTypes.string,
  }),
  setFocusedIndex: PropTypes.func,
};

export default ProfileMenuLinks;
